/**
 * PHOTOPRI - Paper & Frame Simulator JS
 * Awwwards Quality Rendering Prototype - Refined
 */

// GA4 / GTM 共通トラッキング (gtag + dataLayer 両系へ送信、未定義環境は no-op)
function trackSimulator(eventName, params) {
    try {
        const payload = Object.assign({ tool: 'simulator' }, params || {});
        if (typeof window.gtag === 'function') {
            window.gtag('event', eventName, payload);
        }
        if (Array.isArray(window.dataLayer)) {
            window.dataLayer.push(Object.assign({ event: eventName }, payload));
        }
    } catch (e) { /* swallow */ }
}

const MATERIALS = {
    // Frames are now flat base color with subtle texture
    alum_black: { base: '#1e1e1e', isWood: false },
    alum_white: { base: '#f4f4f4', isWood: false },
    alum_silver: { base: '#b0b3b5', isWood: false },
    alum_gold: { base: '#e8d48b', isWood: false },
    wood_natural: { base: '#f2e3c6', isWood: true },
    wood_black: { base: '#252525', isWood: true },
    wood_white: { base: '#e6e6e6', isWood: true },
    wood_brown: { base: '#4e3524', isWood: true }
};

// --- Ambient Background Animation (Awwwards Style) ---
class GridGlassAnimation {
    constructor(canvas) {
        this.canvas = canvas;
        this.ctx = canvas.getContext('2d');
        this.width = window.innerWidth;
        this.height = window.innerHeight;
        this.time = 0;
        this.gridSize = 60;
        this.resize();
        
        window.addEventListener('resize', () => this.resize());
    }
    
    resize() {
        this.width = window.innerWidth;
        this.height = window.innerHeight;
        this.canvas.width = this.width;
        this.canvas.height = this.height;
    }
    
    animate() {
        this.ctx.clearRect(0, 0, this.width, this.height);
        this.time += 0.005;
        
        // Clean light grid lines for white background
        this.ctx.strokeStyle = 'rgba(0, 0, 0, 0.06)'; 
        this.ctx.lineWidth = 0.5;
        
        // Vertical lines with distortion
        for (let x = 0; x <= this.width; x += this.gridSize) {
            this.ctx.beginPath();
            for (let y = 0; y <= this.height; y += 10) {
                const offsetX = Math.sin(y * 0.003 + this.time) * Math.cos(x * 0.003 + this.time) * 15;
                if (y === 0) this.ctx.moveTo(x + offsetX, y);
                else this.ctx.lineTo(x + offsetX, y);
            }
            this.ctx.stroke();
        }
        
        // Horizontal lines with distortion
        for (let y = 0; y <= this.height; y += this.gridSize) {
            this.ctx.beginPath();
            for (let x = 0; x <= this.width; x += 10) {
                const offsetY = Math.cos(x * 0.003 + this.time) * Math.sin(y * 0.003 + this.time) * 15;
                if (x === 0) this.ctx.moveTo(x, y + offsetY);
                else this.ctx.lineTo(x, y + offsetY);
            }
            this.ctx.stroke();
        }
        
        requestAnimationFrame(() => this.animate());
    }
}
// -----------------------------------------------------

class SimulatorState {
    constructor() {
        this.mode = 'paper_only';
        
        // Dimensions in mm
        this.paper = { w: 210, h: 297, texture: 'white' };
        
        // Artwork Margins inside Paper (in mm)
        this.margins = { t: 0, r: 0, b: 0, l: 0, sync: true };
        
        this.mat = { windowW: 190, windowH: 277, color: 'white', margins: { t: 50, r: 50, b: 50, l: 50, sync: true } };
        this.frame = { w: 210, h: 297, thickness: 10, overlap: 5, material: 'alum_black' };
        
        // Options
        this.borderless = false;
        this.bleedAmount = 0; // Extra bleed in mm beyond the cover-fit edge
        this.bleedConfirmed = false; // When true, bleed overlay is hidden
        this.printLayout = 'with_margin'; // 'with_margin' | 'without_margin' | 'full_data'
        this.marginProcessing = 'margin_spec'; // 'margin_spec' | 'image_size_spec'
        this.fullData = false; // When true, image renders 1:1 no scaling
        this.autoMarginApplied = false; // True if margin was automatically calcualted
        this.showDimensions = true; // Toggle for dimension labels visibility
        
        // Env
        this.bg = 'neutral';
        this.guides = false;
        
        // Image & Viewport
        this.image = null;
        this.imageLoaded = false;
        // Original (pre-ICC) base64 data URL & per-paper-handle cache of soft-proofed Image objects
        this.originalImageDataUrl = null;
        this.iccCache = {};
        this.iccEnabled = false;
        this.iccPaperHandle = '';
        this.iccBusy = false;
        // Viewport center offset for panning (moving the whole paper)
        this.panX = 0;
        this.panY = 0;
        
        // Image offset for panning inside the mask
        this.imagePanX = 0;
        this.imagePanY = 0;
        
        // Smooth Animation State
        this.currentScale = 0;
        this.targetScale = 0;
        this.animPanX = 0;
        this.animPanY = 0;
        
        // Paper outline flash (temporary highlight when paper size changes in mat mode)
        this.paperOutlineFlashAlpha = 0;
    }
}

const state = new SimulatorState();
let canvas, ctx;
let ambientAnim = null;
let tipInterval = null;
let isDragging = false;
let startDragX, startDragY;

const TIPS = [
    "注文後に3営業日でお届け<br><span style='font-size:0.6em;opacity:0.6;font-weight:300;'>(枚数により異なります)</span>",
    "カスタムサイズ対応OK<br><span style='font-size:0.6em;opacity:0.6;font-weight:300;'>ミリ単位で指定可能</span>",
    "プロファイルは<br>AdobeRGB対応",
    "マットボードの余白設定も<br>自由自在"
];

function init() {
    canvas = document.getElementById('previewCanvas');
    ctx = canvas.getContext('2d');
    
    // Init Ambient Background
    const ambientCanvas = document.getElementById('ambientCanvas');
    if (ambientCanvas) {
        ambientAnim = new GridGlassAnimation(ambientCanvas);
        ambientAnim.animate();
        startTipsRotation();
    }
    
    // Lock UI until image upload
    const panelContent = document.querySelector('.panel-content');
    const artistTools = document.querySelector('.artist-tools');
    if (panelContent) panelContent.classList.add('locked-until-upload');
    if (artistTools) artistTools.classList.add('locked-until-upload');
    
    bindEvents();
    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);
    initICCIntegration();

    trackSimulator('simulator_init');

    // Initial draw loop
    requestAnimationFrame(renderLoop);
}

function startTipsRotation() {
    const tipEl = document.getElementById('ambientTip');
    if (!tipEl) return;
    
    // Configure logo and header HTML
    const logoUrl = "https://cdn.shopify.com/s/files/1/0530/5122/8352/files/logoblk.svg?v=1771983790";
    const logoHtml = `<img src="${logoUrl}" alt="PHOTOPRI" style="height: 12px; vertical-align: middle; margin-top: -2px; margin-left: 2px; margin-right: 2px;">`;
    const headerHtml = `<div style="font-weight: 600; font-size: 0.75rem; margin-bottom: 4px; display: flex; align-items: center; justify-content: flex-end; white-space: nowrap;">作品印刷なら${logoHtml}</div>`;
    
    const updateTip = () => {
        const tipText = TIPS[Math.floor(Math.random() * TIPS.length)];
        tipEl.innerHTML = headerHtml + tipText;
    };
    
    updateTip();
    tipEl.classList.add('visible');
    
    tipInterval = setInterval(() => {
        tipEl.classList.remove('visible');
        setTimeout(() => {
            updateTip();
            tipEl.classList.add('visible');
        }, 1000); // Wait for fade out
    }, 5000); // Change tip every 5 seconds
}

function resizeCanvas() {
    const container = document.getElementById('canvasContainer');
    const dpr = window.devicePixelRatio || 1;
    canvas.width = container.clientWidth * dpr;
    canvas.height = container.clientHeight * dpr;
    
    canvas.style.width = `${container.clientWidth}px`;
    canvas.style.height = `${container.clientHeight}px`;
    
    ctx.scale(dpr, dpr);
    draw(true);
}

function bindEvents() {
    // Mode
    document.querySelectorAll('input[name="sim_mode"]').forEach(radio => {
        radio.addEventListener('change', (e) => {
            const uiMode = e.target.value;
            if (uiMode === 'paper_frame') {
                const chkMat = document.getElementById('chkMatBoard');
                state.mode = (chkMat && chkMat.checked) ? 'paper_mat_frame' : 'paper_frame';
            } else {
                state.mode = uiMode;
            }
            // Center viewport on mode change
            resetPan();
            applyAutoMarginsIfApplicable();
            updatePanelVisibility();
            validateConstraints();
            draw();
        });
    });
    
    // Preset Sizes
    document.getElementById('presetSize').addEventListener('change', (e) => {
        trackSimulator('simulator_change_preset', {
            preset_value: e.target.value,
            preset_label: (e.target.selectedOptions[0] && e.target.selectedOptions[0].textContent || '').trim()
        });
        if(e.target.value === 'custom') return;
        const [w, h] = e.target.value.split(',').map(Number);
        
        // Apply logic: keep orientation of current W/H. If current is landscape, swap preset w/h
        const isLandscape = state.paper.w > state.paper.h;
        state.paper.w = isLandscape ? Math.max(w,h) : Math.min(w,h);
        state.paper.h = isLandscape ? Math.min(w,h) : Math.max(w,h);
        
        document.getElementById('paperW').value = state.paper.w;
        document.getElementById('paperH').value = state.paper.h;
        
        applyAutoMarginsIfApplicable();
        
        // Auto-run omakase mat margins when paper size changes in mat mode
        if (state.mode === 'paper_mat_frame') {
            autoOmakaseMatMargins();
            state.paperOutlineFlashAlpha = 1.0;
        }
        
        updatePanelVisibility(); // sync frame if needed
        validateConstraints();
        draw();
    });
    
    // Paper Inputs
    const updatePaper = (w, h) => {
        state.paper.w = parseFloat(w) || 0;
        state.paper.h = parseFloat(h) || 0;
        document.getElementById('presetSize').value = 'custom';
        applyAutoMarginsIfApplicable();
        
        // Auto-run omakase mat margins when paper size changes in mat mode
        if (state.mode === 'paper_mat_frame') {
            autoOmakaseMatMargins();
            // Trigger paper outline flash to show where the paper is relative to mat
            state.paperOutlineFlashAlpha = 1.0;
        }
        
        updatePanelVisibility();
        validateConstraints();
        draw();
    };
    document.getElementById('paperW').addEventListener('input', (e) => { updatePaper(e.target.value, state.paper.h); });
    document.getElementById('paperH').addEventListener('input', (e) => { updatePaper(state.paper.w, e.target.value); });
    document.getElementById('paperTexture').addEventListener('change', (e) => {
        state.paper.texture = e.target.value;
        trackSimulator('simulator_change_texture', { texture: e.target.value });
    });
    
    // Margins
    const syncMarg = (val) => {
        state.margins.t = state.margins.b = state.margins.l = state.margins.r = val;
        document.getElementById('marginT').value = val;
        document.getElementById('marginB').value = val;
        document.getElementById('marginL').value = val;
        document.getElementById('marginR').value = val;
    };
    const makeMargHandler = (key) => (e) => {
        const val = parseFloat(e.target.value) || 0;
        state.autoMarginApplied = false; // User manually overridden
        if(state.margins.sync) syncMarg(val);
        else state.margins[key] = val;
        validateConstraints();
    };
    document.getElementById('marginT').addEventListener('input', makeMargHandler('t'));
    document.getElementById('marginB').addEventListener('input', makeMargHandler('b'));
    document.getElementById('marginL').addEventListener('input', makeMargHandler('l'));
    document.getElementById('marginR').addEventListener('input', makeMargHandler('r'));
    
    const btnSyncMargins = document.getElementById('btnSyncMargins');
    btnSyncMargins.addEventListener('click', () => {
        state.margins.sync = !state.margins.sync;
        btnSyncMargins.style.color = state.margins.sync ? 'var(--text-primary)' : 'var(--text-secondary)';
        if(state.margins.sync) syncMarg(state.margins.t);
    });
    btnSyncMargins.style.color = 'var(--text-primary)'; // default sync on
    
    // Mat
    document.getElementById('matW').addEventListener('input', (e) => { state.mat.windowW = parseFloat(e.target.value) || 0; validateConstraints(); });
    document.getElementById('matH').addEventListener('input', (e) => { state.mat.windowH = parseFloat(e.target.value) || 0; validateConstraints(); });
    document.getElementById('matColor').addEventListener('change', (e) => {
        state.mat.color = e.target.value;
        trackSimulator('simulator_change_mat_color', { mat_color: e.target.value });
    });
    
    // Mat Margins
    const syncMatMarg = (val) => {
        state.mat.margins.t = state.mat.margins.b = state.mat.margins.l = state.mat.margins.r = val;
        document.getElementById('matMarginT').value = val;
        document.getElementById('matMarginB').value = val;
        document.getElementById('matMarginL').value = val;
        document.getElementById('matMarginR').value = val;
    };
    const makeMatMargHandler = (key) => (e) => {
        const val = parseFloat(e.target.value) || 0;
        if(state.mat.margins.sync) syncMatMarg(val);
        else state.mat.margins[key] = val;
        validateConstraints();
    };
    document.getElementById('matMarginT').addEventListener('input', makeMatMargHandler('t'));
    document.getElementById('matMarginB').addEventListener('input', makeMatMargHandler('b'));
    document.getElementById('matMarginL').addEventListener('input', makeMatMargHandler('l'));
    document.getElementById('matMarginR').addEventListener('input', makeMatMargHandler('r'));
    
    const btnSyncMatMargins = document.getElementById('btnSyncMatMargins');
    if(btnSyncMatMargins) {
        btnSyncMatMargins.addEventListener('click', () => {
            state.mat.margins.sync = !state.mat.margins.sync;
            btnSyncMatMargins.style.color = state.mat.margins.sync ? 'var(--text-primary)' : 'var(--text-secondary)';
            if(state.mat.margins.sync) syncMatMarg(state.mat.margins.t);
            validateConstraints();
        });
        btnSyncMatMargins.style.color = 'var(--text-primary)'; // default sync on
    }
    
    // Omakase logic for Mat
    const btnOmakaseMat = document.getElementById('btnOmakaseMat');
    if(btnOmakaseMat) {
        btnOmakaseMat.addEventListener('click', () => {
             trackSimulator('simulator_omakase_mat');
             const shortSide = Math.min(state.mat.windowW, state.mat.windowH);
             let baseMargin = Math.round(shortSide * 0.15); // 15% of short window side
             baseMargin = Math.max(30, Math.min(baseMargin, 150)); // clamp safely
             
             state.mat.margins.sync = false;
             if(btnSyncMatMargins) btnSyncMatMargins.style.color = 'var(--text-secondary)';
             
             state.mat.margins.t = baseMargin;
             state.mat.margins.l = baseMargin;
             state.mat.margins.r = baseMargin;
             state.mat.margins.b = Math.round(baseMargin * 1.3); // Heavy bottom (bottom weight approx 30% more)
             
             document.getElementById('matMarginT').value = state.mat.margins.t;
             document.getElementById('matMarginL').value = state.mat.margins.l;
             document.getElementById('matMarginR').value = state.mat.margins.r;
             document.getElementById('matMarginB').value = state.mat.margins.b;
             
             validateConstraints();
             draw();
        });
    }
    
    // Borderless toggle
    const chkBorderless = document.getElementById('chkBorderless');
    const bleedControl = document.getElementById('bleedControl');
    const bleedSlider = document.getElementById('bleedSlider');
    const marginGridWrap = document.getElementById('marginGridWrap');
    const bleedConfirmedDiv = document.getElementById('bleedConfirmed');
    
    if(chkBorderless) {
        chkBorderless.addEventListener('change', (e) => {
            state.borderless = e.target.checked;
            trackSimulator('simulator_toggle_borderless', { borderless: e.target.checked });
            document.querySelectorAll('.margin-grid input[id^="margin"]').forEach(el => el.disabled = state.borderless);
            document.getElementById('btnSyncMargins').style.opacity = state.borderless ? '0.3' : '1';
            
            // Show/hide bleed options & margin grid
            if (state.borderless) {
                if (state.bleedConfirmed) {
                    if (bleedControl) bleedControl.style.display = 'none';
                    if (bleedConfirmedDiv) bleedConfirmedDiv.style.display = 'block';
                } else {
                    if (bleedControl) bleedControl.style.display = 'block';
                    if (bleedConfirmedDiv) bleedConfirmedDiv.style.display = 'none';
                }
                if (marginGridWrap) marginGridWrap.style.display = 'none';
            } else {
                if (bleedControl) bleedControl.style.display = 'none';
                if (bleedConfirmedDiv) bleedConfirmedDiv.style.display = 'none';
                if (marginGridWrap) marginGridWrap.style.display = '';
                // Since user turned off borderless, they expect to see the natural letterbox margins
                applyAutoMarginsIfApplicable();
            }
            
            draw();
        });
    }
    
    // Bleed confirm / edit buttons
    const btnBleedConfirm = document.getElementById('btnBleedConfirm');
    // bleedConfirmedDiv already declared above
    const bleedConfirmedVal = document.getElementById('bleedConfirmedVal');
    const btnBleedEdit = document.getElementById('btnBleedEdit');
    
    if (btnBleedConfirm) {
        btnBleedConfirm.addEventListener('click', () => {
            state.bleedConfirmed = true;
            if (bleedControl) bleedControl.style.display = 'none';
            if (bleedConfirmedDiv) {
                bleedConfirmedDiv.style.display = 'block';
                if (bleedConfirmedVal) bleedConfirmedVal.textContent = state.bleedAmount;
            }
            draw();
        });
    }
    
    if (btnBleedEdit) {
        btnBleedEdit.addEventListener('click', () => {
            state.bleedConfirmed = false;
            if (bleedControl) bleedControl.style.display = 'block';
            if (bleedConfirmedDiv) bleedConfirmedDiv.style.display = 'none';
            draw();
        });
    }
    
    if (bleedSlider) {
        const bleedNumber = document.getElementById('bleedNumber');
        
        bleedSlider.addEventListener('input', (e) => {
            state.bleedAmount = parseInt(e.target.value) || 0;
            if (bleedNumber) bleedNumber.value = state.bleedAmount;
            draw();
        });
        
        if (bleedNumber) {
            bleedNumber.addEventListener('input', (e) => {
                state.bleedAmount = Math.max(0, parseInt(e.target.value) || 0);
                bleedSlider.value = Math.min(state.bleedAmount, parseInt(bleedSlider.max));
                draw();
            });
        }
    }
    
    // ===== Print Layout Mode System =====
    const printLayoutRadios = document.querySelectorAll('input[name="print_layout"]');
    const withMarginOptions = document.getElementById('withMarginOptions');
    const withoutMarginOptions = document.getElementById('withoutMarginOptions');
    
    function updatePrintLayoutUI() {
        const mode = state.printLayout;
        if (withMarginOptions) withMarginOptions.style.display = mode === 'with_margin' ? '' : 'none';
        if (withoutMarginOptions) withoutMarginOptions.style.display = mode === 'without_margin' ? '' : 'none';
        
        const chk = document.getElementById('chkBorderless');
        if (mode === 'without_margin') {
            state.borderless = true;
            state.bleedAmount = 0;
            if (chk) chk.checked = true;
        } else {
            state.borderless = false;
            if (chk) chk.checked = false;
            applyAutoMarginsIfApplicable();
        }
        
        const marginInputs = document.querySelectorAll('.margin-grid input[id^="margin"]');
        const syncBtn = document.getElementById('btnSyncMargins');
        marginInputs.forEach(el => el.disabled = mode !== 'with_margin');
        if (syncBtn) syncBtn.style.opacity = mode !== 'with_margin' ? '0.3' : '1';
        
        draw();
    }
    
    printLayoutRadios.forEach(radio => {
        radio.addEventListener('change', (e) => {
            state.printLayout = e.target.value;
            updatePrintLayoutUI();
        });
    });
    
    const marginProcessingSelect = document.getElementById('marginProcessing');
    const marginSpecWrap = document.getElementById('marginSpecWrap');
    const imageSizeSpecWrap = document.getElementById('imageSizeSpecWrap');
    
    if (marginProcessingSelect) {
        marginProcessingSelect.addEventListener('change', (e) => {
            state.marginProcessing = e.target.value;
            if (marginSpecWrap) marginSpecWrap.style.display = state.marginProcessing === 'margin_spec' ? '' : 'none';
            if (imageSizeSpecWrap) imageSizeSpecWrap.style.display = state.marginProcessing === 'image_size_spec' ? '' : 'none';
            if (state.marginProcessing === 'image_size_spec') calcMarginsFromImageSize();
        });
    }
    
    // Image Size Spec: auto-calc other dimension from aspect ratio
    let _imgSizeUpdating = false; // prevent circular updates
    
    function getImageAspectRatio() {
        if (!state.imageLoaded || !state.image) return null;
        const w = state.image.naturalWidth || state.image.width;
        const h = state.image.naturalHeight || state.image.height;
        if (!w || !h) return null;
        return { w, h, ratio: w / h };
    }
    
    function calcMarginsFromImageSize(source) {
        if (_imgSizeUpdating) return;
        _imgSizeUpdating = true;
        
        const shortEl = document.getElementById('imgSizeShort');
        const longEl = document.getElementById('imgSizeLong');
        const ar = getImageAspectRatio();
        
        if (ar && shortEl && longEl) {
            const imgShortPx = Math.min(ar.w, ar.h);
            const imgLongPx = Math.max(ar.w, ar.h);
            const arShortLong = imgShortPx / imgLongPx; // < 1
            
            if (source === 'short') {
                const sv = parseInt(shortEl.value) || 0;
                if (sv > 0) longEl.value = Math.round(sv / arShortLong);
            } else if (source === 'long') {
                const lv = parseInt(longEl.value) || 0;
                if (lv > 0) shortEl.value = Math.round(lv * arShortLong);
            }
        }
        
        // Now calculate margins from the (possibly auto-filled) values
        const shortVal = parseInt(shortEl?.value) || 0;
        const longVal = parseInt(longEl?.value) || 0;
        
        if (shortVal > 0 && longVal > 0) {
            const imgShort = Math.min(shortVal, longVal);
            const imgLong = Math.max(shortVal, longVal);
            const paperShort = Math.min(state.paper.w, state.paper.h);
            const paperLong = Math.max(state.paper.w, state.paper.h);
            
            const marginShort = Math.max(0, Math.round((paperShort - imgShort) / 2));
            const marginLong = Math.max(0, Math.round((paperLong - imgLong) / 2));
            
            if (state.paper.h >= state.paper.w) {
                state.margins.l = marginShort; state.margins.r = marginShort;
                state.margins.t = marginLong; state.margins.b = marginLong;
            } else {
                state.margins.t = marginShort; state.margins.b = marginShort;
                state.margins.l = marginLong; state.margins.r = marginLong;
            }
            
            document.getElementById('marginT').value = state.margins.t;
            document.getElementById('marginR').value = state.margins.r;
            document.getElementById('marginB').value = state.margins.b;
            document.getElementById('marginL').value = state.margins.l;
            
            state.autoMarginApplied = false;
            draw();
        }
        
        _imgSizeUpdating = false;
    }
    
    const imgSizeShort = document.getElementById('imgSizeShort');
    const imgSizeLong = document.getElementById('imgSizeLong');
    if (imgSizeShort) imgSizeShort.addEventListener('input', () => calcMarginsFromImageSize('short'));
    if (imgSizeLong) imgSizeLong.addEventListener('input', () => calcMarginsFromImageSize('long'));
    
    const btnSwapEdges = document.getElementById('btnSwapEdges');
    if (btnSwapEdges) {
        btnSwapEdges.addEventListener('click', () => {
            const s = document.getElementById('imgSizeShort');
            const l = document.getElementById('imgSizeLong');
            if (s && l) {
                const tmp = s.value;
                s.value = l.value;
                l.value = tmp;
                calcMarginsFromImageSize('short');
            }
        });
    }
    
    // Frame (Thickness / material)
    document.getElementById('frameThickness').addEventListener('input', (e) => {
        state.frame.thickness = parseInt(e.target.value, 10);
        document.getElementById('frameThicknessVal').textContent = state.frame.thickness;
        
        // Constrain overlap so it's always smaller than thickness (max: thickness - 1, min: 1)
        const overlapInput = document.getElementById('frameOverlap');
        const maxOverlap = Math.max(1, state.frame.thickness - 1);
        overlapInput.max = maxOverlap;
        
        if ((state.frame.overlap || 5) > maxOverlap) {
            state.frame.overlap = maxOverlap;
            overlapInput.value = maxOverlap;
            document.getElementById('frameOverlapVal').textContent = maxOverlap;
        }
        
        changed = true;
    });
    
    document.getElementById('frameOverlap').addEventListener('input', (e) => {
        let val = parseInt(e.target.value, 10);
        const maxOverlap = Math.max(1, (state.frame.thickness || 10) - 1);
        if (val > maxOverlap) {
            val = maxOverlap;
            e.target.value = val;
        }
        state.frame.overlap = val;
        document.getElementById('frameOverlapVal').textContent = state.frame.overlap;
        changed = true;
    });document.getElementById('frameMaterial').addEventListener('change', (e) => state.frame.material = e.target.value);
    
    // Frame Size Preset Dropdown
    const presetFrameSize = document.getElementById('presetFrameSize');
    if (presetFrameSize) {
        presetFrameSize.addEventListener('change', (e) => {
            if (e.target.value === 'custom') return;
            const [w, h] = e.target.value.split(',').map(Number);
            state.frame.w = w;
            state.frame.h = h;
            document.getElementById('frameW').value = w;
            document.getElementById('frameH').value = h;
            updatePanelVisibility();
            validateConstraints();
            draw();
        });
    }
    
    // Frame Size Manual Inputs
    document.getElementById('frameW').addEventListener('input', (e) => {
        state.frame.w = parseFloat(e.target.value) || 0;
        if (presetFrameSize) presetFrameSize.value = 'custom';
        updatePanelVisibility();
        validateConstraints();
        draw();
    });
    document.getElementById('frameH').addEventListener('input', (e) => {
        state.frame.h = parseFloat(e.target.value) || 0;
        if (presetFrameSize) presetFrameSize.value = 'custom';
        updatePanelVisibility();
        validateConstraints();
        draw();
    });
    
    // Mat Board Toggle (within frame mode)
    const chkMatBoard = document.getElementById('chkMatBoard');
    if (chkMatBoard) {
        chkMatBoard.addEventListener('change', (e) => {
            if (e.target.checked) {
                state.mode = 'paper_mat_frame';
                autoOmakaseMatMargins();
            } else {
                state.mode = 'paper_frame';
            }
            updatePanelVisibility();
            validateConstraints();
            draw();
        });
    }
    
    // View tools
    document.querySelectorAll('.tool-btn').forEach(btn => {
        if (btn.id === 'btnRecenter' || btn.id === 'btnUploadImage' || btn.id === 'btnToggleTools' || btn.id === 'btnToggleDimensions') return;
        btn.addEventListener('click', (e) => {
            document.querySelectorAll('.tool-btn').forEach(b => {
                if(b.id !== 'btnRecenter' && b.id !== 'btnUploadImage' && b.id !== 'btnToggleTools' && b.id !== 'btnToggleDimensions') b.classList.remove('active');
            });
            btn.classList.add('active');
            let t = btn.dataset.tool;
            if (t === 'bg') t = 'plain';
            state.view = t;
            changed = true;
        });
    });
    
    // Add logic for mobile artist tools toggle
    const btnToggleTools = document.getElementById('btnToggleTools');
    if (btnToggleTools) {
        btnToggleTools.addEventListener('click', () => {
            btnToggleTools.closest('.artist-tools').classList.toggle('expanded');
        });
    }

    // Tools
    document.querySelectorAll('.tool-btn').forEach(btn => {
        btn.addEventListener('click', () => {
            const tool = btn.dataset.tool;
            if (tool === 'guides') {
                state.guides = !state.guides;
                btn.classList.toggle('active');
            } else if (tool === 'bg') {
                const bgs = ['neutral', 'gallery', 'concrete', 'wood'];
                const idx = bgs.indexOf(state.bg);
                state.bg = bgs[(idx + 1) % bgs.length];
                const wrapper = document.querySelector('.simulator-page-wrapper');
                if (wrapper) wrapper.setAttribute('data-bg', state.bg);
                btn.title = `背景テクスチャを変更 (${state.bg})`;
            }
        });
    });
    
    document.getElementById('btnRecenter').addEventListener('click', resetPan);
    
    // Dimension label toggle
    const btnToggleDimensions = document.getElementById('btnToggleDimensions');
    if (btnToggleDimensions) {
        btnToggleDimensions.addEventListener('click', () => {
            state.showDimensions = !state.showDimensions;
            btnToggleDimensions.classList.toggle('active', state.showDimensions);
            draw();
        });
    }
    
    // Image Upload
    const uploadOverlay = document.getElementById('uploadOverlay');
    const imageUpload = document.getElementById('imageUpload');
    
    const triggerUpload = () => {
        imageUpload.value = ''; // Reset so same file can be re-selected
        imageUpload.click();
    };
    uploadOverlay.addEventListener('click', triggerUpload);
    
    // Dedicated Upload Button in artist tools
    const btnUploadImage = document.getElementById('btnUploadImage');
    if (btnUploadImage) {
        btnUploadImage.addEventListener('click', triggerUpload);
    }
    
    // Drag/Drop Image
    const layout = document.querySelector('.simulator-layout');
    layout.addEventListener('dragover', (e) => {
        e.preventDefault();
        uploadOverlay.style.background = 'rgba(255,255,255,0.05)';
    });
    layout.addEventListener('dragleave', (e) => {
        e.preventDefault();
        uploadOverlay.style.background = 'transparent';
    });
    layout.addEventListener('drop', (e) => {
        e.preventDefault();
        uploadOverlay.style.background = 'transparent';
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            handleImageUpload(e.dataTransfer.files[0]);
        }
    });
    
    imageUpload.addEventListener('change', (e) => {
        if (e.target.files && e.target.files.length > 0) {
            handleImageUpload(e.target.files[0]);
        }
    });

    // Panning interaction
    const container = document.getElementById('canvasContainer');
    container.addEventListener('mousedown', (e) => {
        if(e.button !== 0) return; // Left click only
        isDragging = true;
        startDragX = e.clientX;
        startDragY = e.clientY;
    });
    window.addEventListener('mousemove', (e) => {
        if (!isDragging) return;
        const dx = e.clientX - startDragX;
        const dy = e.clientY - startDragY;
        
        // If image is loaded, panning moves the image instead of the paper
        if (state.imageLoaded) {
            // Apply scale factor so panning feels 1:1 with mouse movement
            state.imagePanX += dx / state.currentScale;
            state.imagePanY += dy / state.currentScale;
        } else {
            // Otherwise, pan the paper
            state.panX += dx;
            state.panY += dy;
        }
        
        startDragX = e.clientX;
        startDragY = e.clientY;
        draw(); // draw immediately while dragging
    });
    window.addEventListener('mouseup', () => { isDragging = false; });
}

function handleImageUpload(file) {
    if (!file.type.startsWith('image/')) {
        trackSimulator('simulator_upload_image', { result: 'invalid_type', mime: file.type });
        return;
    }

    const loader = document.getElementById('loader');
    loader.style.display = 'flex';

    const reader = new FileReader();
    reader.onload = (e) => {
        const img = new Image();
        img.onload = () => {
            state.image = img;
            state.imageLoaded = true;
            trackSimulator('simulator_upload_image', {
                result: 'ok',
                mime: file.type,
                file_size_kb: Math.round(file.size / 1024),
                image_w_px: img.naturalWidth,
                image_h_px: img.naturalHeight
            });
            // Stash original for ICC toggle; reset ICC cache for new image
            state.originalImageDataUrl = e.target.result;
            state.iccCache = {};
            if (typeof refreshICCPreview === 'function') refreshICCPreview();
            document.getElementById('uploadOverlay').classList.add('hidden');
            
            // Unlock UI
            const panelContent = document.querySelector('.panel-content');
            const artistTools = document.querySelector('.artist-tools');
            if (panelContent) panelContent.classList.remove('locked-until-upload');
            if (artistTools) artistTools.classList.remove('locked-until-upload');
            
            const guideBanner = document.getElementById('uploadGuideBanner');
            if (guideBanner) guideBanner.classList.add('hidden');
            
            loader.style.display = 'none';
            resetPan();
            
            // Auto Layout Orientation: Swap paper and mat width/height to match image
            const isImgLandscape = img.width > img.height;
            const isImgSquare = img.width === img.height;
            const isPaperPortrait = state.paper.h > state.paper.w;
            const isPaperLandscape = state.paper.w > state.paper.h;
            
            // Only swap if orientations clearly differ (skip for square images)
            const needsSwap = !isImgSquare && (
                (isImgLandscape && isPaperPortrait) || 
                (!isImgLandscape && isPaperLandscape)
            );
            
            if (needsSwap) {
                // Swap Paper
                [state.paper.w, state.paper.h] = [state.paper.h, state.paper.w];
                document.getElementById('paperW').value = state.paper.w;
                document.getElementById('paperH').value = state.paper.h;
                
                // Also swap Frame dimensions in frame modes so validateConstraints doesn't undo the swap
                if (state.mode === 'paper_frame' || state.mode === 'paper_mat_frame') {
                    [state.frame.w, state.frame.h] = [state.frame.h, state.frame.w];
                    document.getElementById('frameW').value = state.frame.w;
                    document.getElementById('frameH').value = state.frame.h;
                }
                
                // Swap Mat Window
                [state.mat.windowW, state.mat.windowH] = [state.mat.windowH, state.mat.windowW];
                document.getElementById('matWindowW').value = state.mat.windowW;
                document.getElementById('matWindowH').value = state.mat.windowH;
            }
            
            // First validate constraints (which may sync paper <-> frame),
            // THEN calculate auto margins based on the final stable paper dimensions.
            validateConstraints();
            applyAutoMarginsIfApplicable();
            draw();
        };
        img.src = e.target.result;
    };
    reader.readAsDataURL(file);
}

/**
 * Auto-calculate mat margins using the "omakase" golden ratio algorithm.
 * Called automatically when paper size changes in paper_mat_frame mode.
 */
function autoOmakaseMatMargins() {
    const shortSide = Math.min(state.mat.windowW, state.mat.windowH);
    let baseMargin = Math.round(shortSide * 0.15); // 15% of short window side
    baseMargin = Math.max(30, Math.min(baseMargin, 150)); // clamp safely
    
    state.mat.margins.sync = false;
    const btnSyncMatMargins = document.getElementById('btnSyncMatMargins');
    if (btnSyncMatMargins) btnSyncMatMargins.style.color = 'var(--text-secondary)';
    
    state.mat.margins.t = baseMargin;
    state.mat.margins.l = baseMargin;
    state.mat.margins.r = baseMargin;
    state.mat.margins.b = Math.round(baseMargin * 1.3); // Heavy bottom (bottom weight approx 30% more)
    
    document.getElementById('matMarginT').value = state.mat.margins.t;
    document.getElementById('matMarginL').value = state.mat.margins.l;
    document.getElementById('matMarginR').value = state.mat.margins.r;
    document.getElementById('matMarginB').value = state.mat.margins.b;
}

function applyAutoMarginsIfApplicable() {
    if (state.imageLoaded && state.image && !state.borderless && 
        (state.autoMarginApplied || (state.margins.t === 0 && state.margins.r === 0 && state.margins.b === 0 && state.margins.l === 0))) {
        
        // Use intrinsic image dimensions safely
        const nW = state.image.naturalWidth || state.image.width;
        const nH = state.image.naturalHeight || state.image.height;
        if (!nW || !nH) return;

        // Calculate the natural letterbox margin (what the space would be if margins were 0)
        const pW = state.paper.w;
        const pH = state.paper.h;
        const imgRatio = nW / nH;
        const targetRatio = pW / pH;
        
        let naturalMarginX = 0;
        let naturalMarginY = 0;
        
        if (imgRatio > targetRatio) {
            // Image is wider than paper (fits width, leaves top/bottom margin)
            const fitH = pW / imgRatio;
            naturalMarginY = Math.round((pH - fitH) / 2);
        } else {
            // Image is taller than paper (fits height, leaves left/right margin)
            const fitW = pH * imgRatio;
            naturalMarginX = Math.round((pW - fitW) / 2);
        }
        
        state.margins.t = naturalMarginY;
        state.margins.b = naturalMarginY;
        state.margins.l = naturalMarginX;
        state.margins.r = naturalMarginX;
        
        document.getElementById('marginT').value = state.margins.t;
        document.getElementById('marginR').value = state.margins.r;
        document.getElementById('marginB').value = state.margins.b;
        document.getElementById('marginL').value = state.margins.l;
        
        // Disable sync to accurately reflect asymmetric letterboxing
        state.margins.sync = false;
        const btnSyncMargins = document.getElementById('btnSyncMargins');
        if (btnSyncMargins) btnSyncMargins.style.color = 'var(--text-secondary)';
        
        state.autoMarginApplied = true;
    }
}

function validateConstraints() {
    let changed = false;
    
    // In frame modes, paper size is synced to frame inner size.
    // The paper physically spans the entire back of the frame, and the mat (if any) sits on top.
    if (state.mode === 'paper_frame' || state.mode === 'paper_mat_frame') {
        if (state.paper.w !== state.frame.w || state.paper.h !== state.frame.h) {
            state.paper.w = state.frame.w;
            state.paper.h = state.frame.h;
            document.getElementById('paperW').value = state.paper.w;
            document.getElementById('paperH').value = state.paper.h;
            changed = true;
        }
    }
    
    // In paper_mat_frame mode, the frame size is fixed by user.
    // The mat window + mat margins must equal the frame size.
    // If they don't match, we should adjust the mat margins to fit the frame, assuming frame is the master dictating size.
    if (state.mode === 'paper_mat_frame') {
        const expectedFrameW = state.mat.windowW + state.mat.margins.l + state.mat.margins.r;
        const expectedFrameH = state.mat.windowH + state.mat.margins.t + state.mat.margins.b;
        
        if (state.frame.w !== expectedFrameW || state.frame.h !== expectedFrameH) {
            // Adjust mat margins proportionally to fit the frame size to avoid changing the window size
            // However, a simpler approach is to just let the left/right and top/bottom margins absorb the difference
            const diffW = state.frame.w - expectedFrameW;
            const diffH = state.frame.h - expectedFrameH;
            
            state.mat.margins.l += Math.floor(diffW / 2);
            state.mat.margins.r += Math.ceil(diffW / 2);
            state.mat.margins.t += Math.floor(diffH / 2);
            state.mat.margins.b += Math.ceil(diffH / 2);
            
            // Prevent negative margins (if frame is too small for window, shrink window)
            if (state.mat.margins.l < 0) { state.mat.windowW += state.mat.margins.l; state.mat.margins.l = 0; }
            if (state.mat.margins.r < 0) { state.mat.windowW += state.mat.margins.r; state.mat.margins.r = 0; }
            if (state.mat.margins.t < 0) { state.mat.windowH += state.mat.margins.t; state.mat.margins.t = 0; }
            if (state.mat.margins.b < 0) { state.mat.windowH += state.mat.margins.b; state.mat.margins.b = 0; }
            
            document.getElementById('matMarginL').value = state.mat.margins.l;
            document.getElementById('matMarginR').value = state.mat.margins.r;
            document.getElementById('matMarginT').value = state.mat.margins.t;
            document.getElementById('matMarginB').value = state.mat.margins.b;
            document.getElementById('matW').value = state.mat.windowW;
            document.getElementById('matH').value = state.mat.windowH;
            changed = true;
        }
    }
    
    // Limits on paper size margins (cannot exceed paper size)
    if (state.mode === 'paper_only' || state.mode === 'paper_frame') {
        const maxMarginH = Math.max(0, state.paper.h - 10); // Allow at least 10mm printable area
        if (state.margins.t + state.margins.b > maxMarginH) {
            const h = Math.max(0, Math.floor(maxMarginH / 2));
            state.margins.t = state.margins.b = h;
            document.getElementById('marginT').value = h;
            document.getElementById('marginB').value = h;
            changed = true;
        }
        if (state.margins.l + state.margins.r >= state.paper.w) {
            const w = Math.max(0, (state.paper.w / 2) - 1);
            state.margins.l = state.margins.r = w;
            document.getElementById('marginL').value = w;
            document.getElementById('marginR').value = w;
            changed = true;
        }
    }
    
    return changed;
}

function updatePanelVisibility() {
    const paperControls = document.getElementById('paperControls');
    const matControls = document.getElementById('matControls');
    const frameControls = document.getElementById('frameControls');
    const parent = paperControls.parentElement;
    
    // Find the first divider (between mode selector and controls)
    const paperDivider = paperControls.previousElementSibling;

    if (state.mode === 'paper_only') {
        paperControls.style.display = 'block';
        matControls.style.display = 'none';
        frameControls.style.display = 'none';
        
        // Show all paper sub-elements (size preset, W/H, texture)
        const paperHeader = paperControls.querySelector('.group-header');
        const paperPreset = paperControls.querySelector('.stylish-select');
        const paperInputRow = paperControls.querySelector('.input-row');
        const paperTexture = paperControls.querySelectorAll('.stylish-select')[1];
        if (paperHeader) paperHeader.style.display = '';
        if (paperPreset) paperPreset.style.display = '';
        if (paperInputRow) paperInputRow.style.display = '';
        if (paperTexture) paperTexture.style.display = '';
        
        // Original order: divider → paper
        const firstSection = parent.querySelector('#matControls, #frameControls');
        if (firstSection) {
            if (paperDivider && paperDivider.classList.contains('divider')) parent.insertBefore(paperDivider, firstSection);
            parent.insertBefore(paperControls, firstSection);
        }
        
    } else if (state.mode === 'paper_frame') {
        // Show paper controls but hide paper-size-specific elements (keep margins visible)
        paperControls.style.display = 'block';
        matControls.style.display = 'none';
        frameControls.style.display = 'block';
        
        // Hide paper header, preset, W/H row and texture select (user edits frame size instead)
        const paperHeader = paperControls.querySelector('.group-header');
        const paperPreset = paperControls.querySelector('.stylish-select');
        const paperInputRow = paperControls.querySelector('.input-row');
        const paperTexture = paperControls.querySelectorAll('.stylish-select')[1];
        if (paperHeader) paperHeader.style.display = 'none';
        if (paperPreset) paperPreset.style.display = 'none';
        if (paperInputRow) paperInputRow.style.display = 'none';
        if (paperTexture) paperTexture.style.display = 'none';
        
        // In paper_frame (no mat), paper == frame inner. Sync paper FROM frame.
        state.paper.w = state.frame.w;
        state.paper.h = state.frame.h;
        document.getElementById('paperW').value = state.paper.w;
        document.getElementById('paperH').value = state.paper.h;
        
        // Reorder: divider → frame → paper(margins only)
        const refNode = matControls;
        if (paperDivider && paperDivider.classList.contains('divider')) parent.insertBefore(paperDivider, refNode);
        parent.insertBefore(frameControls, refNode);
        parent.insertBefore(paperControls, refNode);
        
    } else if (state.mode === 'paper_mat_frame') {
        paperControls.style.display = 'none';
        matControls.style.display = 'block';
        frameControls.style.display = 'block';
        
        // Reorder: divider → frame → mat
        const anchor = parent.querySelector('footer') || parent.lastElementChild;
        if (paperDivider && paperDivider.classList.contains('divider')) parent.insertBefore(paperDivider, anchor);
        parent.insertBefore(frameControls, anchor);
        parent.insertBefore(matControls, anchor);
    }
}

function resetPan() {
    state.panX = 0;
    state.panY = 0;
    state.imagePanX = 0;
    state.imagePanY = 0;
}

function renderLoop() {
    draw();
    requestAnimationFrame(renderLoop);
}

function draw(instant = false) {
    if (!ctx || !canvas) return;
    
    const container = document.getElementById('canvasContainer');
    const cw = container.clientWidth;
    const ch = container.clientHeight;
    
    ctx.clearRect(0, 0, cw, ch);
    
    // Calculate physical total dimensions
    let totalW_mm = state.paper.w;
    let totalH_mm = state.paper.h;
    
    // Default overlap to 5 if not set
    const overlap = state.frame.overlap !== undefined ? state.frame.overlap : 5;

    if (state.mode === 'paper_frame') {
        const visibleW = state.paper.w - (overlap * 2);
        const visibleH = state.paper.h - (overlap * 2);
        totalW_mm = visibleW + (state.frame.thickness * 2);
        totalH_mm = visibleH + (state.frame.thickness * 2);
    } else if (state.mode === 'paper_mat_frame') {
        const visibleW = state.frame.w - (overlap * 2);
        const visibleH = state.frame.h - (overlap * 2);
        totalW_mm = visibleW + (state.frame.thickness * 2);
        totalH_mm = visibleH + (state.frame.thickness * 2);
    }

    // Use dynamic padding to ensure it fits nicely on smaller screens and doesn't look too huge
    // On mobile, increase padding to prevent dimension text from overlapping the artwork
    const isMobile = window.innerWidth <= 900;
    const padding = isMobile ? Math.max(140, Math.min(cw, ch) * 0.25) : Math.max(80, Math.min(cw, ch) * 0.12);
    const availableW = cw - padding * 2;
    const availableH = ch - padding * 2;
    if (availableW <= 0 || availableH <= 0 || totalW_mm <= 0 || totalH_mm <= 0) return;
    
    // Cap the maximum scale so small postcards don't grow to fill the entire monitor
    const maxScale = 3.5;
    const rawTargetScale = Math.min(availableW / totalW_mm, availableH / totalH_mm, maxScale);
    
    // Easing for scale/pan
    if (instant || state.currentScale === 0) {
        state.currentScale = rawTargetScale;
        state.animPanX = state.panX;
        state.animPanY = state.panY;
    } else {
        state.currentScale += (rawTargetScale - state.currentScale) * 0.08;
        state.animPanX += (state.panX - state.animPanX) * 0.15;
        state.animPanY += (state.panY - state.animPanY) * 0.15;
    }
    
    const scale = state.currentScale;
    const cx = cw / 2 + state.animPanX;
    const cy = ch / 2 + state.animPanY;

    ctx.save();
    ctx.translate(cx, cy);

    // --- 1. Drop Shadow for the entire frame / paper ---
    if (state.mode === 'paper_only') {
        ctx.shadowColor = 'rgba(0,0,0,0.2)';
        ctx.shadowBlur = 60;
        ctx.shadowOffsetY = 30;
    } else {
        // Wall shadow for framed items
        ctx.shadowColor = 'rgba(0,0,0,0.5)';
        ctx.shadowBlur = 45;
        ctx.shadowOffsetY = 25;
        ctx.shadowOffsetX = 10;
        
        // Draw a solid rect spanning the outer dimensions to cast the main wall shadow
        // Prevent it from rendering visually by making it match the frame later, or just fill it with background
        ctx.fillStyle = 'rgba(0,0,0,1)';
        const outerW = totalW_mm * scale;
        const outerH = totalH_mm * scale;
        ctx.fillRect(-outerW/2, -outerH/2, outerW, outerH);
    }

    // For framed items, reset shadow immediately (frame draws its own wall shadow)
    if (state.mode !== 'paper_only') {
        ctx.shadowColor = 'transparent';
    }

    // --- 2. Paper Layer ---
    let pW = state.paper.w * scale;
    let pH = state.paper.h * scale;
    
    // In framed modes, clip the entire drawing area to the frame inner bounds to absolutely prevent leaking
    let fInnerW, fInnerH;
    if (state.mode === 'paper_mat_frame' || state.mode === 'paper_frame') {
        fInnerW = ((state.mode === 'paper_mat_frame' ? state.frame.w : state.paper.w) - overlap * 2) * scale;
        fInnerH = ((state.mode === 'paper_mat_frame' ? state.frame.h : state.paper.h) - overlap * 2) * scale;
        ctx.save();
        ctx.beginPath();
        ctx.rect(-fInnerW/2, -fInnerH/2, fInnerW, fInnerH);
        ctx.clip();
    }
    
    // Usually paper is centered to the frame
    ctx.fillStyle = state.paper.texture === 'white' ? '#FFFFFF' : '#F4F1E8';
    ctx.fillRect(-pW/2, -pH/2, pW, pH);
    
    // Now reset shadow for paper_only (it was kept active to cast shadow on the fillRect above)
    ctx.shadowColor = 'transparent';

    // Apply faint grain to paper
    ctx.fillStyle = 'rgba(200,200,200,0.02)';
    ctx.fillRect(-pW/2, -pH/2, pW, pH);

    // --- 3. Artwork Image Layer ---
    if (state.imageLoaded && state.image) {
        ctx.save();
        
        // Artwork prints onto the paper based on margins
        const mt = state.borderless ? 0 : state.margins.t * scale;
        const mb = state.borderless ? 0 : state.margins.b * scale;
        const ml = state.borderless ? 0 : state.margins.l * scale;
        const mr = state.borderless ? 0 : state.margins.r * scale;
        
        const drawAreaW = pW - (ml + mr);
        const drawAreaH = pH - (mt + mb);
        
        // X/Y center of the new print box relative to paper center
        const xOff = (ml - mr) / 2;
        const yOff = (mt - mb) / 2;
        
        // Clip to margin box so we don't print over explicit paper margins
        ctx.beginPath();
        ctx.rect(-pW/2 + ml, -pH/2 + mt, drawAreaW, drawAreaH);
        ctx.clip();
        
        ctx.translate(xOff, yOff); // Move to center of printable area
        
        if (drawAreaW > 0 && drawAreaH > 0) {
            const imgRatio = state.image.width / state.image.height;
            const targetRatio = drawAreaW / drawAreaH;
            
            let dw, dh;
            // If Borderless, image covers the target entirely (bleed), otherwise it is contained.
            if (imgRatio > targetRatio) {
                if (state.borderless) {
                    dh = drawAreaH;
                    dw = drawAreaH * imgRatio;
                } else {
                    dw = drawAreaW;
                    dh = drawAreaW / imgRatio;
                }
            } else {
                if (state.borderless) {
                    dw = drawAreaW;
                    dh = drawAreaW / imgRatio;
                } else {
                    dh = drawAreaH;
                    dw = drawAreaH * imgRatio;
                }
            }
            
            // Apply extra bleed amount (scale up further)
            if (state.borderless && state.bleedAmount > 0) {
                const bleedPx = state.bleedAmount * scale;
                const extraScaleX = (dw + bleedPx * 2) / dw;
                const extraScaleY = (dh + bleedPx * 2) / dh;
                const extraScale = Math.max(extraScaleX, extraScaleY);
                dw *= extraScale;
                dh *= extraScale;
            }
            
            // In framed modes, image panning allows users to move the image inside the mat hole
            const maxPanX = Math.max(0, (dw - drawAreaW) / 2);
            const maxPanY = Math.max(0, (dh - drawAreaH) / 2);
            state.imagePanX = Math.max(-maxPanX, Math.min(state.imagePanX, maxPanX));
            state.imagePanY = Math.max(-maxPanY, Math.min(state.imagePanY, maxPanY));
            
            // Multiply for natural ink soaking effect onto paper
            ctx.globalCompositeOperation = 'multiply';
            ctx.drawImage(state.image, (-dw/2) + state.imagePanX, (-dh/2) + state.imagePanY, dw, dh);
            ctx.globalCompositeOperation = 'source-over';
            
            // Update Image Profile Stats HUD with Quality Tiers
            const statsDiv = document.getElementById('imageProfileStats');
            if (statsDiv) {
                // Calculate effective print DPI along the wider dimension
                const printWidthMM = dw / scale; // actual mm of drawn area
                const dpi = Math.round(state.image.width / (printWidthMM / 25.4));
                
                // Quality Tiers
                let qualityLabel, qualityColor, qualityIcon;
                if (dpi >= 300) {
                    qualityLabel = '高画質（写真印刷推奨）';
                    qualityColor = '#34C759'; // Green
                    qualityIcon = '◉';
                } else if (dpi >= 200) {
                    qualityLabel = '良好（一般印刷OK）';
                    qualityColor = '#007AFF'; // Blue
                    qualityIcon = '◉';
                } else if (dpi >= 150) {
                    qualityLabel = 'やや粗い（大判向き）';
                    qualityColor = '#FF9500'; // Orange
                    qualityIcon = '◉';
                } else {
                    qualityLabel = '低解像度（非推奨）';
                    qualityColor = '#FF3B30'; // Red
                    qualityIcon = '◉';
                }
                
                statsDiv.innerHTML = `
                画像プロファイル: <span class="val-highlight">${state.image.width} × ${state.image.height} px</span>
                印刷解像度目安: <span class="val-highlight" style="color: ${qualityColor}">${qualityIcon} ${dpi} dpi</span> <span style="color: ${qualityColor}">- ${qualityLabel}</span>
                `.trim();
                statsDiv.style.display = 'block';
            }
        }
        ctx.restore();
    } else {
        const statsDiv = document.getElementById('imageProfileStats');
        if (statsDiv) statsDiv.style.display = 'none';
    }
    
    // Close the inner frame area clip to allow the mat board and frame to draw normally
    if (state.mode === 'paper_mat_frame' || state.mode === 'paper_frame') {
        ctx.restore(); 
    }
    
    // --- Mat Board (Realistic Thickness & Shadow) ---
    if (state.mode === 'paper_mat_frame') {
        let mXOff = 0, mYOff = 0;
        const iW = state.frame.w * scale;
        const iH = state.frame.h * scale;
        const mW = state.mat.windowW * scale;
        const mH = state.mat.windowH * scale;
        const bevelWidth = 2.5; // mm-equivalent width of the 45-degree bevel cut
        
        mXOff = (state.mat.margins.l - state.mat.margins.r) / 2 * scale;
        mYOff = (state.mat.margins.t - state.mat.margins.b) / 2 * scale;
        
        ctx.save();
        
        // 1. Drop shadow from the mat onto the artwork
        ctx.shadowColor = 'rgba(0, 0, 0, 0.4)';
        ctx.shadowBlur = 8;
        ctx.shadowOffsetX = 2;
        ctx.shadowOffsetY = 4;
        
        // Draw the mat cutout (outer matches frame inner exactly, so no white halo leaks out)
        ctx.beginPath();
        ctx.rect(-iW/2, -iH/2, iW, iH); // Outer bound
        ctx.rect(-mW/2 + mXOff, -mH/2 + mYOff, mW, mH); // Inner hole
        ctx.fillStyle = state.mat.color === 'white' ? '#FAFAFA' : '#141414';
        ctx.fill('evenodd');
        ctx.shadowColor = 'transparent'; // Reset shadow
        
        // 2. Bevel Cut 3D Effect (The 45-degree exposed core of the matboard)
        ctx.translate(mXOff, mYOff); // Now translate to draw the bevels exactly around the window
        
        const isWhiteMat = state.mat.color === 'white';
        const coreBase = isWhiteMat ? 250 : 230; // Bright core
        
        // Top bevel (catches light)
        ctx.fillStyle = `rgb(${coreBase}, ${coreBase}, ${coreBase})`;
        ctx.beginPath();
        ctx.moveTo(-mW/2, -mH/2);
        ctx.lineTo(mW/2, -mH/2);
        ctx.lineTo(mW/2 + bevelWidth, -mH/2 - bevelWidth);
        ctx.lineTo(-mW/2 - bevelWidth, -mH/2 - bevelWidth);
        ctx.fill();
        
        // Bottom bevel (in shadow)
        ctx.fillStyle = `rgb(${coreBase - 60}, ${coreBase - 60}, ${coreBase - 55})`;
        ctx.beginPath();
        ctx.moveTo(-mW/2, mH/2);
        ctx.lineTo(mW/2, mH/2);
        ctx.lineTo(mW/2 + bevelWidth, mH/2 + bevelWidth);
        ctx.lineTo(-mW/2 - bevelWidth, mH/2 + bevelWidth);
        ctx.fill();
        
        // Left bevel (mid-light)
        ctx.fillStyle = `rgb(${coreBase - 20}, ${coreBase - 20}, ${coreBase - 20})`;
        ctx.beginPath();
        ctx.moveTo(-mW/2, -mH/2);
        ctx.lineTo(-mW/2, mH/2);
        ctx.lineTo(-mW/2 - bevelWidth, mH/2 + bevelWidth);
        ctx.lineTo(-mW/2 - bevelWidth, -mH/2 - bevelWidth);
        ctx.fill();
        
        // Right bevel (mid-shadow)
        ctx.fillStyle = `rgb(${coreBase - 40}, ${coreBase - 40}, ${coreBase - 40})`;
        ctx.beginPath();
        ctx.moveTo(mW/2, -mH/2);
        ctx.lineTo(mW/2, mH/2);
        ctx.lineTo(mW/2 + bevelWidth, mH/2 + bevelWidth);
        ctx.lineTo(mW/2 + bevelWidth, -mH/2 - bevelWidth);
        ctx.fill();
        
        // Very subtle sharp inner edge line
        ctx.strokeStyle = isWhiteMat ? 'rgba(0,0,0,0.05)' : 'rgba(0,0,0,0.4)';
        ctx.lineWidth = 0.5;
        ctx.strokeRect(-mW/2, -mH/2, mW, mH);
        
        ctx.restore();
    }
    
    // --- Paper Outline Flash (temporary visualization when paper size changes in Mat mode) ---
    if (state.mode === 'paper_mat_frame' && state.paperOutlineFlashAlpha > 0) {
        ctx.save();
        const alpha = state.paperOutlineFlashAlpha;
        
        // Draw a dashed outline showing where the paper is behind the mat
        ctx.setLineDash([6, 4]);
        ctx.strokeStyle = `rgba(0, 122, 255, ${alpha})`;
        ctx.lineWidth = 2;
        ctx.strokeRect(-pW/2, -pH/2, pW, pH);
        ctx.setLineDash([]); // Reset dash
        
        // Draw semi-transparent fill to highlight paper area
        ctx.fillStyle = `rgba(0, 122, 255, ${alpha * 0.05})`;
        ctx.fillRect(-pW/2, -pH/2, pW, pH);
        
        // Paper size label at the bottom of the paper outline
        const labelText = `用紙: ${state.paper.w} × ${state.paper.h} mm`;
        ctx.font = `${Math.max(11, 14 * (scale / 2))}px -apple-system, BlinkMacSystemFont, sans-serif`;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'top';
        
        // Background pill for the label
        const metrics = ctx.measureText(labelText);
        const labelW = metrics.width + 16;
        const labelH = 24;
        const labelX = 0;
        const labelY = pH/2 + 6;
        
        ctx.fillStyle = `rgba(0, 122, 255, ${alpha * 0.9})`;
        ctx.beginPath();
        ctx.roundRect(labelX - labelW/2, labelY, labelW, labelH, 4);
        ctx.fill();
        
        ctx.fillStyle = `rgba(255, 255, 255, ${alpha})`;
        ctx.fillText(labelText, labelX, labelY + 5);
        
        ctx.restore();
        
        // Fade out the flash
        state.paperOutlineFlashAlpha -= 0.015;
        if (state.paperOutlineFlashAlpha < 0) state.paperOutlineFlashAlpha = 0;
    }

    // --- Flat Frame (Photorealistic Real Texture Pattern) ---
    if (state.mode !== 'paper_only') {
        const outerW = totalW_mm * scale;
        const outerH = totalH_mm * scale;
        let innerW, innerH;
        
        if (state.mode === 'paper_mat_frame') {
            innerW = (state.frame.w - overlap * 2) * scale;
            innerH = (state.frame.h - overlap * 2) * scale;
        } else {
            innerW = (state.paper.w - overlap * 2) * scale;
            innerH = (state.paper.h - overlap * 2) * scale;
        }
        
        const thick = (outerW - innerW) / 2;
        const matDef = MATERIALS[state.frame.material] || MATERIALS.alum_black;
        
        // Wall shadow (soft and deep)
        ctx.shadowColor = 'rgba(0,0,0,0.5)';
        ctx.shadowBlur = 45;
        ctx.shadowOffsetY = 25;
        ctx.shadowOffsetX = 10;
        
        // Solid base for shadow casting
        ctx.beginPath();
        ctx.rect(-outerW/2, -outerH/2, outerW, outerH);
        ctx.rect(-innerW/2, -innerH/2, innerW, innerH);
        ctx.fillStyle = matDef.base;
        ctx.fill("evenodd");
        ctx.shadowColor = 'transparent'; 
        
        // Helper: Miter segment
        const drawMiterSegment = (side) => {
            ctx.beginPath();
            if (side === 0) { // Top
                ctx.moveTo(-outerW/2, -outerH/2);
                ctx.lineTo(outerW/2, -outerH/2);
                ctx.lineTo(innerW/2, -innerH/2);
                ctx.lineTo(-innerW/2, -innerH/2);
            } else if (side === 1) { // Right
                ctx.moveTo(outerW/2, -outerH/2);
                ctx.lineTo(outerW/2, outerH/2);
                ctx.lineTo(innerW/2, innerH/2);
                ctx.lineTo(innerW/2, -innerH/2);
            } else if (side === 2) { // Bottom
                ctx.moveTo(outerW/2, outerH/2);
                ctx.lineTo(-outerW/2, outerH/2);
                ctx.lineTo(-innerW/2, innerH/2);
                ctx.lineTo(innerW/2, innerH/2);
            } else if (side === 3) { // Left
                ctx.moveTo(-outerW/2, outerH/2);
                ctx.lineTo(-outerW/2, -outerH/2);
                ctx.lineTo(-innerW/2, -innerH/2);
                ctx.lineTo(-innerW/2, innerH/2);
            }
            ctx.closePath();
            ctx.fill();
        };

        // --- Use High-Quality Loaded Patterns ---
        // Ensure textures are loaded once globally
        if (!window.__photopriTextures) {
            window.__photopriTextures = { wood: new Image(), metal: new Image() };
            const wrapper = document.querySelector('.simulator-page-wrapper');
            window.__photopriTextures.wood.src = wrapper?.dataset.woodUrl || '../assets/retina-wood.png';
            window.__photopriTextures.metal.src = wrapper?.dataset.metalUrl || '../assets/brushed-alum.png';
            
            // Trigger redraw when textures load to guarantee they show up
            window.__photopriTextures.wood.onload = () => requestAnimationFrame(draw);
            window.__photopriTextures.metal.onload = () => requestAnimationFrame(draw);
        }
        
        const img = matDef.isWood ? window.__photopriTextures.wood : window.__photopriTextures.metal;
        let pattern = null;
        if (img.complete && img.naturalWidth > 0) {
            pattern = ctx.createPattern(img, 'repeat');
        }
        
        // Apply pattern to each of the 4 mitered segments
        for(let side=0; side<4; side++) {
            ctx.save();
            drawMiterSegment(side);
            ctx.clip(); // Restrict drawing to the trapezoid piece
            
            // 1. Base fill (giving the wood/metal its color)
            ctx.fillStyle = matDef.base;
            ctx.fillRect(-outerW/2, -outerH/2, outerW, outerH);
            
            const isHorizontal = (side === 0 || side === 2);
            const length = isHorizontal ? outerW : outerH;
            const width = thick;
            
            // Transform matrix for the pattern so grain flows correctly along the frame piece
            ctx.translate(
                isHorizontal ? -outerW/2 : (side===1 ? innerW/2 : -outerW/2),
                isHorizontal ? (side===0 ? -outerH/2 : innerH/2) : -outerH/2
            );
            
            // Rotate the pattern so the texture runs along the length of the frame segment
            if (!isHorizontal) ctx.rotate(Math.PI/2);
            
            // 2. Apply High-Res Pattern Overlay
            if (pattern) {
                if (matDef.isWood) {
                    // For dark woods (black, brown), multiply hides the grain. Use luminosity to apply the texture's light/dark values directly.
                    const isDark = state.frame.material.includes('black') || state.frame.material.includes('brown');
                    ctx.globalCompositeOperation = isDark ? 'luminosity' : 'multiply';
                    ctx.globalAlpha = isDark ? 0.5 : 0.45;
                } else {
                    ctx.globalCompositeOperation = 'source-over';
                    ctx.globalAlpha = 0.7;
                }
                ctx.fillStyle = pattern;
                ctx.fillRect(0, 0, length, width);
            }
            
            // Reset for lighting passes
            ctx.globalCompositeOperation = 'source-over';
            ctx.globalAlpha = 1.0;
            
            // 3. 3D Optical Illusion (Highlights & Shadows for Beveling)
            // Determine light direction (Light coming from Top-Left)
            // side 0: Top (catches maximum light, strong highlight)
            // side 1: Right (mid shadow)
            // side 2: Bottom (deep shadow)
            // side 3: Left (mid light)
            
            // Create a gradient across the thickness of the frame profile
            const gradient = ctx.createLinearGradient(0, 0, 0, width);
            
            if (matDef.isWood) {
                // Wood profile: usually flat or slightly rounded with crisp inner/outer edges
                if (side === 0) { // Top: lit from above
                    gradient.addColorStop(0, 'rgba(255,255,255,0.15)'); // Outer edge highlight
                    gradient.addColorStop(0.1, 'rgba(255,255,255,0.05)');
                    gradient.addColorStop(0.9, 'rgba(0,0,0,0.0)');
                    gradient.addColorStop(1, 'rgba(0,0,0,0.3)');     // Inner edge shadow dropping into pic
                } else if (side === 1) { // Right: mid shadow
                    gradient.addColorStop(0, 'rgba(0,0,0,0.1)');
                    gradient.addColorStop(0.9, 'rgba(0,0,0,0.2)');
                    gradient.addColorStop(1, 'rgba(0,0,0,0.4)');
                } else if (side === 2) { // Bottom: deep shadow
                    gradient.addColorStop(0, 'rgba(0,0,0,0.4)');     // Outer edge deep shadow underneath
                    gradient.addColorStop(0.1, 'rgba(0,0,0,0.25)');
                    gradient.addColorStop(0.9, 'rgba(0,0,0,0.1)');
                    gradient.addColorStop(1, 'rgba(255,255,255,0.05)'); // Inner edge catches bounce light
                } else { // Left: mid light
                    gradient.addColorStop(0, 'rgba(255,255,255,0.08)');
                    gradient.addColorStop(0.9, 'rgba(0,0,0,0.05)');
                    gradient.addColorStop(1, 'rgba(0,0,0,0.25)');
                }
            } else {
                // Metal profile: highly reflective, sharp specular highlights
                if (side === 0) {
                    gradient.addColorStop(0, 'rgba(255,255,255,0.6)'); // Sharp outer highlight
                    gradient.addColorStop(0.05, 'rgba(255,255,255,0.1)');
                    gradient.addColorStop(0.5, 'rgba(0,0,0,0.0)');
                    gradient.addColorStop(0.95, 'rgba(0,0,0,0.1)');
                    gradient.addColorStop(1, 'rgba(0,0,0,0.4)'); // Crisp inner shadow
                } else if (side === 1) {
                    gradient.addColorStop(0, 'rgba(0,0,0,0.15)');
                    gradient.addColorStop(0.1, 'rgba(255,255,255,0.1)'); // Side reflection
                    gradient.addColorStop(0.9, 'rgba(0,0,0,0.2)');
                    gradient.addColorStop(1, 'rgba(0,0,0,0.45)');
                } else if (side === 2) {
                    gradient.addColorStop(0, 'rgba(0,0,0,0.5)'); // Outer bottom corner in dark
                    gradient.addColorStop(0.1, 'rgba(0,0,0,0.1)');
                    gradient.addColorStop(0.9, 'rgba(255,255,255,0.05)');
                    gradient.addColorStop(1, 'rgba(255,255,255,0.3)'); // Inner bottom bevel catches top light
                } else {
                    gradient.addColorStop(0, 'rgba(255,255,255,0.2)');
                    gradient.addColorStop(0.1, 'rgba(0,0,0,0.05)');
                    gradient.addColorStop(0.9, 'rgba(0,0,0,0.1)');
                    gradient.addColorStop(1, 'rgba(0,0,0,0.3)');
                }
            }
            
            // Draw the 3D lighting gradient
            ctx.fillStyle = gradient;
            ctx.globalCompositeOperation = 'overlay'; // Blend lighting naturally
            ctx.globalAlpha = 0.8;
            ctx.fillRect(0, 0, length, width);
            
            ctx.restore();
            
            // 4. Miter joint (45-degree corner line)
            // Drawn after restore to ensure it renders correctly on top
            ctx.beginPath();
            // Joint color depends on material (darker for wood, crisper for metal)
            ctx.strokeStyle = matDef.isWood ? 'rgba(0, 0, 0, 0.4)' : 'rgba(0, 0, 0, 0.2)';
            ctx.lineWidth = matDef.isWood ? 0.6 : 0.4;
            
            if (side === 0) { // Top-Left joint
                ctx.moveTo(-outerW/2, -outerH/2);
                ctx.lineTo(-innerW/2, -innerH/2);
            } else if (side === 1) { // Top-Right joint
                ctx.moveTo(outerW/2, -outerH/2);
                ctx.lineTo(innerW/2, -innerH/2);
            } else if (side === 2) { // Bottom-Right joint
                ctx.moveTo(outerW/2, outerH/2);
                ctx.lineTo(innerW/2, innerH/2);
            } else if (side === 3) { // Bottom-Left joint
                ctx.moveTo(-outerW/2, outerH/2);
                ctx.lineTo(-innerW/2, innerH/2);
            }
            ctx.stroke();
            
            // Subtle highlight parallel to the joint to simulate a tiny gap/bevel at the corner
            if (side === 0 || side === 1) {
                ctx.beginPath();
                ctx.strokeStyle = 'rgba(255, 255, 255, 0.15)';
                ctx.lineWidth = 0.4;
                if (side === 0) {
                    ctx.moveTo(-outerW/2 + 0.5, -outerH/2 + 0.5);
                    ctx.lineTo(-innerW/2 + 0.5, -innerH/2 + 0.5);
                } else {
                    ctx.moveTo(outerW/2 - 0.5, -outerH/2 + 0.5);
                    ctx.lineTo(innerW/2 - 0.5, -innerH/2 + 0.5);
                }
                ctx.stroke();
            }
        }
        
        // Inner drop shadow (Frame casting subtle flat shadow onto mat or artwork)
        ctx.save();
        ctx.rect(-innerW/2, -innerH/2, innerW, innerH);
        ctx.clip(); 
        
        ctx.shadowColor = 'rgba(0,0,0,0.5)';
        ctx.shadowBlur = 8;
        ctx.shadowOffsetX = 1;
        ctx.shadowOffsetY = 4;
        ctx.strokeStyle = 'rgba(0,0,0,0.5)';
        ctx.lineWidth = 1;
        ctx.strokeRect(-innerW/2 - 1, -innerH/2 - 1, innerW + 2, innerH + 2);
        ctx.restore();
        
        // Solid thin border to give frame a hard geometric limit
        ctx.strokeStyle = 'rgba(0,0,0,0.15)';
        ctx.lineWidth = 0.5;
        ctx.strokeRect(-outerW/2, -outerH/2, outerW, outerH); 
    }
    
    // --- Composition Guides ---
    if (state.guides) {
        let actW, actH, ox=0, oy=0;
        // Determine area based on mode
        if (state.mode === 'paper_mat_frame') {
            actW = state.mat.windowW * scale;
            actH = state.mat.windowH * scale;
            if (state.mat.bottomWeight) oy = -(state.frame.h * scale * 0.04);
        } else {
            const mt = state.margins.t * scale;
            const mb = state.margins.b * scale;
            const ml = state.margins.l * scale;
            const mr = state.margins.r * scale;
            actW = (state.paper.w * scale) - ml - mr;
            actH = (state.paper.h * scale) - mt - mb;
            ox = -(ml - mr)/2;
            oy = (mt - mb)/2;
        }
        
        ctx.translate(ox, oy);
        
        ctx.strokeStyle = 'rgba(0, 255, 200, 0.4)';
        ctx.lineWidth = 1;

        ctx.beginPath();
        // Thirds
        ctx.moveTo(-actW/2 + actW/3, -actH/2);
        ctx.lineTo(-actW/2 + actW/3, actH/2);
        ctx.moveTo(-actW/2 + actW*2/3, -actH/2);
        ctx.lineTo(-actW/2 + actW*2/3, actH/2);
        
        ctx.moveTo(-actW/2, -actH/2 + actH/3);
        ctx.lineTo(actW/2, -actH/2 + actH/3);
        ctx.moveTo(-actW/2, -actH/2 + actH*2/3);
        ctx.lineTo(actW/2, -actH/2 + actH*2/3);
        ctx.stroke();
        
        // Center cross
        ctx.strokeStyle = 'rgba(255, 100, 100, 0.5)';
        ctx.beginPath();
        ctx.moveTo(-5, 0); ctx.lineTo(5, 0);
        ctx.moveTo(0, -5); ctx.lineTo(0, 5);
        ctx.stroke();
    }
    
    // --- Dimension Overlays ---
    drawDimensions(ctx, scale, totalW_mm, totalH_mm);
    
    // --- Bleed Overlay (only shown when editing, hidden after confirm) ---
    if (state.borderless && state.bleedAmount > 0 && state.imageLoaded && !state.bleedConfirmed) {
        const bleedPx = state.bleedAmount * scale;
        
        // Determine the printable area dimensions
        let printAreaW, printAreaH;
        if (state.mode === 'paper_mat_frame') {
            printAreaW = state.mat.windowW * scale;
            printAreaH = state.mat.windowH * scale;
        } else {
            printAreaW = state.paper.w * scale;
            printAreaH = state.paper.h * scale;
        }
        
        // Recalculate bleed image dimensions
        const imgRatio2 = state.image.width / state.image.height;
        const targetRatio2 = printAreaW / printAreaH;
        let bDw, bDh;
        if (imgRatio2 > targetRatio2) {
            bDh = printAreaH; bDw = printAreaH * imgRatio2;
        } else {
            bDw = printAreaW; bDh = printAreaW / imgRatio2;
        }
        // Apply extra bleed scale
        const exSX = (bDw + bleedPx * 2) / bDw;
        const exSY = (bDh + bleedPx * 2) / bDh;
        const exS = Math.max(exSX, exSY);
        bDw *= exS; bDh *= exS;
        
        ctx.save();
        
        // Clip to ONLY the bleed zone (donut: outer = full bleed, inner cutout = printable)
        ctx.beginPath();
        // Outer rect (full bleed area)
        ctx.rect(-bDw/2, -bDh/2, bDw, bDh);
        // Inner rect (printable area to exclude)
        ctx.rect(-printAreaW/2, -printAreaH/2, printAreaW, printAreaH);
        ctx.clip('evenodd');
        
        // Draw ghost image only in the clipped bleed zone
        ctx.globalAlpha = 0.3;
        ctx.drawImage(state.image, (-bDw/2) + state.imagePanX, (-bDh/2) + state.imagePanY, bDw, bDh);
        ctx.globalAlpha = 1.0;
        
        ctx.restore();
        
        // Red dashed cut line around printable edge (drawn without clip)
        ctx.save();
        ctx.strokeStyle = 'rgba(255, 59, 48, 0.7)';
        ctx.lineWidth = 2;
        ctx.setLineDash([8, 5]);
        ctx.strokeRect(-printAreaW/2, -printAreaH/2, printAreaW, printAreaH);
        ctx.setLineDash([]);
        ctx.restore();
    }

    ctx.restore();
}

function drawDimensions(ctx, scale, totalW, totalH) {
    if (!state.showDimensions) {
        // Still draw cross-section even if dimensions are hidden
        if (state.mode !== 'paper_only') drawCrossSection();
        return;
    }
    ctx.save();
    
    const container = document.getElementById('canvasContainer');
    const cw = container ? container.clientWidth : 800;
    const isMobile = cw < 600;
    
    // Adaptive font sizes — comfortable on all screens
    const baseFontSize = isMobile
        ? Math.max(12, Math.min(16, cw * 0.035))
        : Math.max(14, Math.min(22, cw * 0.026));
    const subFontSize = Math.max(11, baseFontSize - 1);
    const tinyFontSize = Math.max(10, baseFontSize - 2);
    
    // Outer gap: distance from paper/frame edge to label
    const outerGap = isMobile ? Math.max(18, baseFontSize * 1.4) : Math.max(24, baseFontSize * 2);
    
    const halfW = (totalW * scale) / 2;
    const halfH = (totalH * scale) / 2;
    
    const lineColor = 'rgba(29, 29, 31, 0.25)';
    const lineWidth = 1;
    
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    
    // ─── Outer W label (top) with dimension line ───
    ctx.fillStyle = 'rgba(29, 29, 31, 0.75)';
    ctx.font = `600 ${baseFontSize}px var(--font-heading)`;
    const topLabelY = -halfH - outerGap;
    ctx.fillText(`W ${totalW}`, 0, topLabelY);
    
    // Tick marks for width
    ctx.strokeStyle = lineColor;
    ctx.lineWidth = lineWidth;
    ctx.beginPath();
    ctx.moveTo(-halfW, topLabelY + baseFontSize * 0.7);
    ctx.lineTo(-halfW, -halfH - 4);
    ctx.moveTo(halfW, topLabelY + baseFontSize * 0.7);
    ctx.lineTo(halfW, -halfH - 4);
    ctx.stroke();
    
    // ─── Outer H label (right) with dimension line ───
    ctx.save();
    const rightLabelX = halfW + outerGap;
    ctx.translate(rightLabelX, 0);
    ctx.rotate(Math.PI / 2);
    ctx.fillText(`H ${totalH}`, 0, 0);
    ctx.restore();
    
    ctx.beginPath();
    ctx.moveTo(rightLabelX - baseFontSize * 0.7, -halfH);
    ctx.lineTo(halfW + 4, -halfH);
    ctx.moveTo(rightLabelX - baseFontSize * 0.7, halfH);
    ctx.lineTo(halfW + 4, halfH);
    ctx.stroke();
    
    // ─── Inner labels: depend on mode ───
    if (state.mode === 'paper_mat_frame') {
        const mW = state.mat.windowW * scale;
        const mH = state.mat.windowH * scale;
        const mxOff = (state.mat.margins.l - state.mat.margins.r) / 2 * scale;
        const myOff = (state.mat.margins.t - state.mat.margins.b) / 2 * scale;
        
        // MAT W label — place above the outer frame, below the W label
        ctx.fillStyle = 'rgba(29, 29, 31, 0.5)';
        ctx.font = `500 ${subFontSize}px var(--font-heading)`;
        const matLabelY = -halfH - outerGap * 0.4;
        if (Math.abs(topLabelY - matLabelY) > baseFontSize + 2) {
            ctx.fillText(`MAT ${state.mat.windowW}×${state.mat.windowH}`, 0, matLabelY);
        }
        
        // Mat margin values — in the mat border zone (only if enough space)
        const frameW = state.frame.w * scale;
        const frameH = state.frame.h * scale;
        ctx.fillStyle = 'rgba(29, 29, 31, 0.4)';
        ctx.font = `600 ${tinyFontSize}px var(--font-heading)`;
        
        const matTpx = state.mat.margins.t * scale;
        const matBpx = state.mat.margins.b * scale;
        const matLpx = state.mat.margins.l * scale;
        const matRpx = state.mat.margins.r * scale;
        
        if (matTpx > tinyFontSize + 4) ctx.fillText(`${state.mat.margins.t}`, mxOff, -frameH/2 + matTpx/2);
        if (matBpx > tinyFontSize + 4) ctx.fillText(`${state.mat.margins.b}`, mxOff, frameH/2 - matBpx/2);
        if (matLpx > tinyFontSize + 4) ctx.fillText(`${state.mat.margins.l}`, -frameW/2 + matLpx/2, myOff);
        if (matRpx > tinyFontSize + 4) ctx.fillText(`${state.mat.margins.r}`, frameW/2 - matRpx/2, myOff);
        
    } else if (state.mode === 'paper_only' || state.mode === 'paper_frame') {
        const actW = state.paper.w - state.margins.l - state.margins.r;
        const actH = state.paper.h - state.margins.t - state.margins.b;
        const hasMargins = state.margins.t > 0 || state.margins.r > 0 || state.margins.b > 0 || state.margins.l > 0;
        
        if (hasMargins && !state.borderless) {
            const pW = state.paper.w * scale;
            const pH = state.paper.h * scale;
            const ox = (state.margins.l - state.margins.r) / 2 * scale;
            const oy = (state.margins.t - state.margins.b) / 2 * scale;
            
            // PRINT W — below the outer frame, as a sub-label
            ctx.fillStyle = 'rgba(29, 29, 31, 0.55)';
            ctx.font = `500 ${subFontSize}px var(--font-heading)`;
            const printLabelY = halfH + outerGap;
            ctx.fillText(`PRINT ${actW}×${actH}`, 0, printLabelY);
            
            // Tick marks for print area (bottom)
            const printHalfW = (actW * scale) / 2;
            ctx.strokeStyle = lineColor;
            ctx.lineWidth = lineWidth;
            ctx.beginPath();
            ctx.moveTo(ox - printHalfW, halfH + 4);
            ctx.lineTo(ox - printHalfW, printLabelY - subFontSize * 0.7);
            ctx.moveTo(ox + printHalfW, halfH + 4);
            ctx.lineTo(ox + printHalfW, printLabelY - subFontSize * 0.7);
            ctx.stroke();
            
            // Margin values — in margin zones (only if pixel space is sufficient)
            ctx.fillStyle = 'rgba(29, 29, 31, 0.45)';
            ctx.font = `600 ${tinyFontSize}px var(--font-heading)`;
            
            const tPx = state.margins.t * scale;
            const bPx = state.margins.b * scale;
            const lPx = state.margins.l * scale;
            const rPx = state.margins.r * scale;
            const minZone = tinyFontSize + 4;
            
            if (state.margins.t > 0 && tPx > minZone) ctx.fillText(`${state.margins.t}`, ox, -pH/2 + tPx/2);
            if (state.margins.b > 0 && bPx > minZone) ctx.fillText(`${state.margins.b}`, ox, pH/2 - bPx/2);
            if (state.margins.l > 0 && lPx > minZone) ctx.fillText(`${state.margins.l}`, -pW/2 + lPx/2, oy);
            if (state.margins.r > 0 && rPx > minZone) ctx.fillText(`${state.margins.r}`, pW/2 - rPx/2, oy);
        }
    }
    
    ctx.restore();
    
    // Draw cross-section if applicable
    if (state.mode !== 'paper_only') {
        drawCrossSection();
    }
}

function drawCrossSection() {
    const csCanvas = document.getElementById('crossSectionCanvas');
    if (!csCanvas) return;
    const ctx = csCanvas.getContext('2d');
    const w = csCanvas.width; // 600
    const h = csCanvas.height; // 240
    
    ctx.clearRect(0,0,w,h);
    
    // Base thickness & overlap
    const thick = state.frame.thickness || 10;
    const overlap = state.frame.overlap !== undefined ? state.frame.overlap : 5;
    
    // Dynamic scaling logic
    // Calculate pixelsPerMm dynamically so the frame width takes up a massive portion of the canvas (approx 65%),
    // up to a maximum multiplier, ensuring it fills the available 600px space beautifully on PC.
    const maxFrameVisW = w * 0.65; 
    const pixelsPerMm = Math.min(60, maxFrameVisW / Math.max(1, thick)); 
    const frameVisW = thick * pixelsPerMm;
    const overlapW = overlap * pixelsPerMm;
    
    // X Positions
    const frameOuterX = w - 20; // Anchor near right edge
    const frameInnerX = frameOuterX - frameVisW;
    const artworkEndX = frameInnerX + overlapW;
    
    // Anchor artwork to the left side of the canvas to utilize the full width
    const artworkStartX = 30;
    
    // Y Positions
    const frameTop = 60;
    const frameBot = h - 60;
    const paperTop = 110;
    const paperThick = 14; 
    
    // 1. Draw Architectural Grid Background
    ctx.strokeStyle = 'rgba(0,0,0,0.03)';
    ctx.lineWidth = 1;
    ctx.beginPath();
    for(let i=0; i<w; i+=20) { ctx.moveTo(i, 0); ctx.lineTo(i, h); }
    for(let i=0; i<h; i+=20) { ctx.moveTo(0, i); ctx.lineTo(w, i); }
    ctx.stroke();
    
    ctx.save();
    
    // 2. Artwork/Mat Shadow
    ctx.shadowColor = 'rgba(0,0,0,0.08)';
    ctx.shadowBlur = 12;
    ctx.shadowOffsetY = 6;
    
    // 3. Draw Artwork/Mat
    ctx.beginPath();
    ctx.moveTo(artworkStartX, paperTop);
    ctx.lineTo(artworkEndX, paperTop);
    ctx.lineTo(artworkEndX, paperTop + paperThick);
    ctx.lineTo(artworkStartX, paperTop + paperThick);
    ctx.closePath();
    
    const paperGrad = ctx.createLinearGradient(0, paperTop, 0, paperTop + paperThick);
    paperGrad.addColorStop(0, '#ffffff');
    paperGrad.addColorStop(1, '#e8e8e8');
    ctx.fillStyle = paperGrad;
    ctx.fill();
    
    ctx.shadowColor = 'transparent';
    ctx.strokeStyle = 'rgba(0,0,0,0.15)';
    ctx.lineWidth = 1;
    ctx.stroke();
    
    // Artwork Label
    ctx.font = '500 13px "Noto Sans JP", sans-serif';
    ctx.textAlign = 'center';
    ctx.fillStyle = '#666';
    ctx.fillText('作品/マット', artworkStartX + (artworkEndX - artworkStartX)/2, paperTop + paperThick/2 + 5);
    
    ctx.restore();
    
    // 4. Draw Frame 
    ctx.save();
    const baseColor = MATERIALS[state.frame.material]?.base || '#888';
    
    // Outer Frame Shadow
    ctx.shadowColor = 'rgba(0,0,0,0.15)';
    ctx.shadowBlur = 20;
    ctx.shadowOffsetX = -5;
    ctx.shadowOffsetY = 15;
    
    ctx.beginPath();
    ctx.moveTo(frameInnerX, frameTop);            // Top-Left
    ctx.lineTo(frameOuterX, frameTop);            // Top-Right
    ctx.lineTo(frameOuterX, frameBot);            // Bottom-Right
    ctx.lineTo(artworkEndX, frameBot);            // Bottom rabbet corner
    ctx.lineTo(artworkEndX, paperTop - 2);        // Rabbet inner corner (gap)
    ctx.lineTo(frameInnerX, paperTop - 2);        // Lip bottom
    ctx.closePath();
    
    ctx.fillStyle = baseColor;
    ctx.fill();
    
    ctx.shadowColor = 'transparent';
    ctx.clip(); // Clip shading to the frame shape
    
    // Frame Lighting / Gradient 
    const isWood = MATERIALS[state.frame.material]?.isWood;
    const frameGrad = ctx.createLinearGradient(frameInnerX, frameTop, frameOuterX, frameBot);
    
    if(isWood) {
        frameGrad.addColorStop(0, 'rgba(255,255,255,0.15)');
        frameGrad.addColorStop(0.3, 'rgba(0,0,0,0.05)');
        frameGrad.addColorStop(1, 'rgba(0,0,0,0.4)');
    } else {
        frameGrad.addColorStop(0, 'rgba(255,255,255,0.4)');
        frameGrad.addColorStop(0.2, 'rgba(255,255,255,0.0)');
        frameGrad.addColorStop(0.8, 'rgba(0,0,0,0.1)');
        frameGrad.addColorStop(1, 'rgba(0,0,0,0.6)');
    }
    ctx.fillStyle = frameGrad;
    ctx.fillRect(frameInnerX, frameTop, frameVisW, frameBot - frameTop);
    
    // Sharp edge highlights & bevel shadows
    ctx.fillStyle = 'rgba(255,255,255,0.5)';
    ctx.fillRect(frameInnerX, frameTop, frameVisW, 3); // Top lighting edge
    
    ctx.fillStyle = 'rgba(0,0,0,0.25)';
    ctx.fillRect(frameInnerX, frameTop, 5, paperTop - frameTop); // Rabbet drop shadow
    
    ctx.restore(); // remove clip
    
    // Frame stroke for crisp definition
    ctx.strokeStyle = 'rgba(0,0,0,0.5)';
    ctx.lineWidth = 1.5;
    ctx.stroke();

    // 5. Dimension Lines & Labels
    ctx.font = '600 13px "Outfit", sans-serif';
    ctx.textAlign = 'center';
    
    // Thickness
    ctx.strokeStyle = '#2c2c2c';
    ctx.fillStyle = '#2c2c2c';
    ctx.beginPath();
    ctx.moveTo(frameInnerX, frameTop - 20);
    ctx.lineTo(frameOuterX, frameTop - 20);
    ctx.stroke();
    ctx.fillRect(frameInnerX - 1, frameTop - 25, 2, 11);
    ctx.fillRect(frameOuterX - 1, frameTop - 25, 2, 11);
    ctx.fillText(`${thick} mm`, frameInnerX + frameVisW/2, frameTop - 30);
    
    // Overlap (Pink Accent)
    ctx.strokeStyle = '#e83e8c';
    ctx.fillStyle = '#e83e8c';
    ctx.beginPath();
    ctx.moveTo(frameInnerX, paperTop - 18);
    ctx.lineTo(artworkEndX, paperTop - 18);
    ctx.stroke();
    ctx.fillRect(frameInnerX - 1, paperTop - 23, 2, 11);
    ctx.fillRect(artworkEndX - 1, paperTop - 23, 2, 11);
    
    ctx.font = '600 13px "Outfit", "Noto Sans JP", sans-serif';
    ctx.fillText(`カカリ ${overlap} mm`, frameInnerX + Math.max(overlapW/2, 35), paperTop - 28);
}

/* ===========================================================
 * ADR-0014 Phase 2 — ICC Soft-Proof Integration
 * シミュレーター本体のプレビュー画像を ICC 適用前後で切替
 * =========================================================== */
const ICC_API_BASE = 'https://color-confidence-api-199163109979.asia-northeast1.run.app';

function setICCStatus(msg, mode) {
    const el = document.getElementById('iccStatus');
    if (el) el.textContent = msg;
    const badge = document.getElementById('iccModeBadge');
    if (badge) {
        if (mode === 'on') {
            badge.textContent = 'ON';
            badge.style.background = '#455a64';
            badge.style.color = '#fff';
        } else if (mode === 'busy') {
            badge.textContent = '...';
            badge.style.background = '#ffb74d';
            badge.style.color = '#263238';
        } else {
            badge.textContent = 'OFF';
            badge.style.background = '#b0bec5';
            badge.style.color = '#263238';
        }
    }
}

function initICCIntegration() {
    const sel = document.getElementById('iccPaperSelect');
    const toggle = document.getElementById('iccEnableToggle');
    if (!sel || !toggle) return;

    // Fetch paper list
    fetch(ICC_API_BASE + '/preview/papers', { method: 'GET' })
        .then(r => r.json())
        .then(json => {
            if (!json || !json.papers) throw new Error('papers empty');
            const groups = { '光沢': [], 'マット': [], 'その他': [] };
            json.papers.forEach(p => {
                const g = (p.category in groups) ? p.category : 'その他';
                groups[g].push(p);
            });
            sel.innerHTML = '<option value="">用紙を選んでください</option>';
            Object.keys(groups).forEach(g => {
                if (!groups[g].length) return;
                const og = document.createElement('optgroup');
                og.label = g;
                groups[g].sort((a, b) => a.display_name.localeCompare(b.display_name, 'ja'));
                groups[g].forEach(p => {
                    const opt = document.createElement('option');
                    opt.value = p.handle;
                    opt.textContent = p.display_name + (p.is_shared_profile ? ' (代用ICC)' : '');
                    og.appendChild(opt);
                });
                sel.appendChild(og);
            });
            setICCStatus('用紙を選んでチェックを入れると、プレビューに反映します', 'off');
        })
        .catch(e => {
            sel.innerHTML = '<option value="">用紙リスト取得失敗</option>';
            setICCStatus('用紙リスト取得に失敗しました: ' + (e.message || e), 'off');
        });

    sel.addEventListener('change', () => {
        state.iccPaperHandle = sel.value;
        trackSimulator('simulator_icc_paper_change', {
            icc_paper_handle: sel.value,
            icc_paper_label: (sel.selectedOptions[0] && sel.selectedOptions[0].textContent || '').trim()
        });
        refreshICCPreview();
    });
    toggle.addEventListener('change', () => {
        state.iccEnabled = toggle.checked;
        trackSimulator('simulator_icc_toggle', {
            icc_enabled: toggle.checked,
            icc_paper_handle: state.iccPaperHandle || ''
        });
        refreshICCPreview();
    });
}

function refreshICCPreview() {
    if (!state.imageLoaded || !state.originalImageDataUrl) return;
    const toggle = document.getElementById('iccEnableToggle');
    const enabled = !!(toggle && toggle.checked);
    const handle = state.iccPaperHandle;

    // OFF or no paper → revert to original
    if (!enabled || !handle) {
        setICCStatus(enabled
            ? '用紙を選択するとプレビューに反映します'
            : (handle ? 'チェックを入れると ICC を適用します' : '用紙を選んでチェックを入れると、プレビューに反映します'),
            'off');
        restoreOriginalImage();
        return;
    }

    // Cached result available
    if (state.iccCache[handle]) {
        state.image = state.iccCache[handle];
        setICCStatus('適用中: ' + handle + ' (キャッシュ)', 'on');
        draw();
        return;
    }

    // Need API call
    if (state.iccBusy) return;
    state.iccBusy = true;
    setICCStatus('ICC プロファイルを適用中…', 'busy');
    // Token captured at fetch start; if image changes before onload, discard the result.
    const requestToken = state.originalImageDataUrl;

    fetch(ICC_API_BASE + '/preview/soft-proof', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            image_data: state.originalImageDataUrl,
            paper_handle: handle,
        }),
    })
        .then(r => r.json().then(b => ({ status: r.status, body: b })))
        .then(res => {
            state.iccBusy = false;
            if (!res.body || !res.body.ok) {
                const msg = (res.body && res.body.reason) || 'プレビュー生成失敗';
                setICCStatus('エラー: ' + msg, 'off');
                restoreOriginalImage();
                return;
            }
            const newImg = new Image();
            newImg.onload = () => {
                // Stale fetch guard: discard if user uploaded a new image while fetch was in flight.
                if (state.originalImageDataUrl !== requestToken) return;
                state.iccCache[handle] = newImg;
                const t = document.getElementById('iccEnableToggle');
                if (t && t.checked && state.iccPaperHandle === handle) {
                    state.image = newImg;
                    const paper = res.body.paper || {};
                    let note = '適用中: ' + (paper.display_name || handle);
                    if (paper.is_shared_profile) note += ' / 代用ICC';
                    setICCStatus(note, 'on');
                    draw();
                }
            };
            newImg.onerror = () => {
                if (state.originalImageDataUrl !== requestToken) return;
                setICCStatus('プレビュー画像の読み込みに失敗', 'off');
                restoreOriginalImage();
            };
            newImg.src = ICC_API_BASE + res.body.preview_url;
        })
        .catch(e => {
            state.iccBusy = false;
            setICCStatus('通信エラー: ' + (e && e.message ? e.message : e), 'off');
            restoreOriginalImage();
        });
}

function restoreOriginalImage() {
    if (!state.originalImageDataUrl) return;
    const orig = new Image();
    orig.onload = () => {
        state.image = orig;
        draw();
    };
    orig.src = state.originalImageDataUrl;
}

document.addEventListener('DOMContentLoaded', init);
